// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import tippy from 'tippy.js';

export default class BtnVariant extends WebComponent {
	didMount() {
		const {
			img,
			imgZoom,
			title,
			tooltip,
		} = this.props;

		const btnLabel = this.element.querySelector('label');
		const touchDevice =  'ontouchstart' in window;

		if (!touchDevice) {
			btnLabel.style.backgroundImage = 'url(' + img + ')';
		}
		else {
			btnLabel.classList.add('touch');
			if (!!imgZoom) {
				btnLabel.style.backgroundImage = 'url(' + imgZoom + ')';
			}
		}

		if (!touchDevice) {
      if (!!tooltip) {
        const template = document.querySelector(tooltip);
        this.tip = tippy(btnLabel, {
          //animation: 'shift-toward',
          arrow: true,
          content: template.innerHTML,
          allowHTML: true,
          theme: 'esp-variant',
          placement: 'bottom',
        });
      } else {
        this.tip = tippy(btnLabel, {
          arrow: true,
          theme: 'esp-variant',
          placement: 'bottom',
        });
      }
    }

/*		tippy.browser.onUserInputChange = type => {
			const method = type === 'touch' ? 'enable' : 'disable'
			for (const tooltip of tip.tooltips) {
				tooltip[method]();
			}
		}*/

	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/BtnVariant.js